var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Cấu hình App OneKids",
        visible: _vm.dialogVisible,
        width: "90%",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        top: "3vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "schoolConfigOneKids" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { span: 8 },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "545px" },
                        attrs: {
                          placeholder: "Tìm kiếm theo tên trường",
                          "prefix-icon": "el-icon-search",
                        },
                        on: { input: _vm.filterList },
                        model: {
                          value: _vm.searchByIdName,
                          callback: function ($$v) {
                            _vm.searchByIdName = $$v
                          },
                          expression: "searchByIdName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loadingData,
                          expression: "loadingData",
                        },
                      ],
                      ref: "tableSchool",
                      staticStyle: { "margin-top": "50px" },
                      attrs: {
                        border: "",
                        data: _vm.schoolList,
                        "highlight-current-row": "",
                        "header-cell-style": _vm.tableHeaderColor,
                        "max-height": _vm.$tableMaxHeight,
                        "element-loading-text": _vm.$tableLoading,
                        "element-loading-spinner": "el-icon-loading",
                        "reserve-selection": true,
                      },
                      on: {
                        select: _vm.handleSelectionChange,
                        "select-all": _vm.handleSelectionAll,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "empty",
                          fn: function () {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#409EFF",
                                    "font-size": "16px",
                                  },
                                },
                                [
                                  _c("span", [
                                    _c("i", { staticClass: "el-icon-warning" }),
                                    _vm._v(
                                      "\n                    Không có dữ liệu\n                  "
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "selection",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: "STT",
                          align: "center",
                          width: "50",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { label: "Tên trường" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.id) +
                                      " - " +
                                      _vm._s(scope.row.schoolName)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-top": "15px" },
                      attrs: { span: 23 },
                    },
                    [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(
                          "Chú ý: Lựa chọn trạng thái bật/tắt, tất cả các thay đổi sẽ được áp dụng dựa trên trạng thái đã chọn. "
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "el_tabs_app",
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTab,
                        callback: function ($$v) {
                          _vm.activeTab = $$v
                        },
                        expression: "activeTab",
                      },
                    },
                    [
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "App Teacher", name: "OneTeacher" } },
                        [
                          _c(
                            "div",
                            { staticClass: "container_data" },
                            [
                              _c(
                                "el-tabs",
                                {
                                  staticClass: "al_tabs-on_off",
                                  attrs: { type: "card" },
                                  on: { "tab-click": _vm.handleClick },
                                  model: {
                                    value: _vm.activeTabTeacher,
                                    callback: function ($$v) {
                                      _vm.activeTabTeacher = $$v
                                    },
                                    expression: "activeTabTeacher",
                                  },
                                },
                                [
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Bật", name: "true" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sức khỏe"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .healthShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "healthShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.healthShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .health,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "health",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.health",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sinh nhật"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .birthdayShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "birthdayShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.birthdayShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .birthday,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "birthday",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.birthday",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tiện ích"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .utilityShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "utilityShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.utilityShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .utility,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "utility",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.utility",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Công lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salary,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salary",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salary",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("19")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Bảng lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("20")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Quét mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("21")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Tạo khảo sát"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .surveyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "surveyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.surveyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .survey,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "survey",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.survey",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("22")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qlAttendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qlAttendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qlAttendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qlAttendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qlAttendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qlAttendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("23")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý nhận diện AI"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceAIShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceAIShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceAIShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceAI,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceAI",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceAI",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Tắt", name: "false" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sức khỏe"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .healthShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "healthShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.healthShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .health,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "health",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.health",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sinh nhật"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .birthdayShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "birthdayShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.birthdayShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .birthday,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "birthday",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.birthday",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tiện ích"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .utilityShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "utilityShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.utilityShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .utility,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "utility",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.utility",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Công lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salary,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salary",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salary",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("19")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Bảng lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .salaryNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "salaryNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.salaryNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("20")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Quét mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("21")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Tạo khảo sát"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .surveyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "surveyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.surveyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .survey,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "survey",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.survey",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("22")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qlAttendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qlAttendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qlAttendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .qlAttendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "qlAttendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.qlAttendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("23")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý nhận diện AI"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceAIShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceAIShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceAIShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconTeacherData
                                                                    .attendanceAI,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconTeacherData,
                                                                      "attendanceAI",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconTeacherData.attendanceAI",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "App Kids", name: "OneKids" } },
                        [
                          _c(
                            "div",
                            { staticClass: "container_data" },
                            [
                              _c(
                                "el-tabs",
                                {
                                  staticClass: "al_tabs-on_off",
                                  attrs: { type: "card" },
                                  on: { "tab-click": _vm.clickParent },
                                  model: {
                                    value: _vm.activeTabParent,
                                    callback: function ($$v) {
                                      _vm.activeTabParent = $$v
                                    },
                                    expression: "activeTabParent",
                                  },
                                },
                                [
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Bật", name: "true" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý học phí"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newTuitionShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newTuitionShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newTuitionShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newTuition,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newTuition",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newTuition",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Con yêu"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .kidsInfoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "kidsInfoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.kidsInfoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .kidsInfo,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "kidsInfo",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.kidsInfo",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Quét mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Khảo sát"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .surveyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "surveyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.surveyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .survey,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "survey",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.survey",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Tắt", name: "false" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý học phí"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newTuitionShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newTuitionShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newTuitionShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newTuition,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newTuition",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newTuition",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Con yêu"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .kidsInfoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "kidsInfoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.kidsInfoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .kidsInfo,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "kidsInfo",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.kidsInfo",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Quét mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Khảo sát"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .surveyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "surveyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.surveyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconParentData
                                                                    .survey,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconParentData,
                                                                      "survey",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconParentData.survey",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-tab-pane",
                        { attrs: { label: "App Plus", name: "OnePlus" } },
                        [
                          _c(
                            "div",
                            { staticClass: "container_data" },
                            [
                              _c(
                                "el-tabs",
                                {
                                  staticClass: "al_tabs-on_off",
                                  attrs: { type: "card" },
                                  on: { "tab-click": _vm.handleClickPlus },
                                  model: {
                                    value: _vm.activeTabPlus,
                                    callback: function ($$v) {
                                      _vm.activeTabPlus = $$v
                                    },
                                    expression: "activeTabPlus",
                                  },
                                },
                                [
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Bật", name: "true" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhân sự"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .employeeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "employeeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.employeeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .employee,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "employee",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.employee",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học sinh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .kidsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "kidsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.kidsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .kids,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "kids",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.kids",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sức khỏe"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .healthShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "healthShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.healthShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .health,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "health",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.health",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sinh nhật"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .birthdayShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "birthdayShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.birthdayShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .birthday,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "birthday",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.birthday",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            " Quản lý học phí\n                          "
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Công lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salary,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salary",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salary",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tiện ích"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .utilityShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "utilityShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.utilityShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .utility,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "utility",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.utility",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("19")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("20")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("21")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lịch sử"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .smsAppHistoryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "smsAppHistoryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.smsAppHistoryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .smsAppHistory,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "smsAppHistory",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.smsAppHistory",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("22")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thông báo hệ thống"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .notifyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "notifyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.notifyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .notify,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "notify",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.notify",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("23")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Hỗ trợ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .supportShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "supportShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.supportShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .support,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "support",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.support",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("24")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thu chi nội bộ"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cashInternalShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cashInternalShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cashInternalShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cashInternal,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cashInternal",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cashInternal",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("25")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Ví"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .walletShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "walletShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.walletShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .wallet,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "wallet",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.wallet",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("26")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("27")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Xin nghỉ nhân sự"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("28")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Chấm công nhân sự\n                          "
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("29")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Công lương nhân sự"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("30")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thống kê công lương"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .statisticSalaryTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "statisticSalaryTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.statisticSalaryTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .statisticSalaryTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "statisticSalaryTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.statisticSalaryTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("31")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Bảng lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("32")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Tổng học sinh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .totalKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "totalKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.totalKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .totalKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "totalKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.totalKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("33")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Đang học"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studyingKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studyingKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studyingKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studyingKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studyingKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studyingKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("34")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đã điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("35")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Chưa điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .noAttendanceKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "noAttendanceKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.noAttendanceKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .noAttendanceKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "noAttendanceKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.noAttendanceKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("36")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Đi học"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .goSchoolKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "goSchoolKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.goSchoolKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .goSchoolKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "goSchoolKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.goSchoolKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("37")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đã điểm danh về"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .leaveSchoolKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "leaveSchoolKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.leaveSchoolKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .leaveSchoolKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "leaveSchoolKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.leaveSchoolKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("38")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đi học dự kiến"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnFutureStatusShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnFutureStatusShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnFutureStatusShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnFutureStatus,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnFutureStatus",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnFutureStatus",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("39")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("40")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận diện"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .faceRecognitionShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "faceRecognitionShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.faceRecognitionShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .faceRecognition,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "faceRecognition",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.faceRecognition",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("41")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qlAttendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qlAttendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qlAttendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qlAttendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qlAttendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qlAttendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("42")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý nhận diện AI"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceAIShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceAIShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceAIShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceAI,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceAI",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceAI",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-tab-pane",
                                    { attrs: { label: "Tắt", name: "false" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-1" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("1")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhân sự"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .employeeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "employeeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.employeeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .employee,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "employee",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.employee",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("2")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học sinh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .kidsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "kidsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.kidsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .kids,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "kids",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.kids",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("3")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lời nhắn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .messageShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "messageShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.messageShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .message,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "message",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.message",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("4")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Dặn thuốc"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .medicineShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "medicineShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.medicineShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .medicine,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "medicine",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.medicine",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("5")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Xin nghỉ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absent,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absent",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absent",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("6")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Điểm danh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("7")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận xét"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .evaluateShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "evaluateShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.evaluateShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .evaluate,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "evaluate",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.evaluate",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("8")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Album ảnh"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .albumShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "albumShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.albumShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .album,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "album",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.album",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("9")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sức khỏe"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .healthShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "healthShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.healthShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .health,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "health",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.health",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("10")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học tập"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learn,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learn",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learn",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("11")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Thực đơn"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .menuShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "menuShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.menuShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .menu,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "menu",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.menu",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("12")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Video"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .videoShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "videoShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.videoShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .video,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "video",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.video",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("13")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Camera"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cameraShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cameraShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cameraShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .camera,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "camera",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.camera",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("14")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Sinh nhật"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .birthdayShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "birthdayShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.birthdayShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .birthday,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "birthday",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.birthday",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("15")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            " Quản lý học phí\n                          "
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("16")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Học phí"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFeesShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFeesShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFeesShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studentFees,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studentFees",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studentFees",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("17")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(" Công lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salary,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salary",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salary",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("18")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tiện ích"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .utilityShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "utilityShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.utilityShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .utility,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "utility",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.utility",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("19")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Facebook"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .facebookShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "facebookShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.facebookShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .facebook,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "facebook",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.facebook",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("20")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Góp ý"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .feedbackShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "feedbackShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.feedbackShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .feedback,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "feedback",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.feedback",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("21")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Lịch sử"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .smsAppHistoryShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "smsAppHistoryShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.smsAppHistoryShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .smsAppHistory,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "smsAppHistory",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.smsAppHistory",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "table-icon-2" },
                                            [
                                              _c(
                                                "table",
                                                {
                                                  staticClass: "table-data",
                                                  attrs: { border: "" },
                                                },
                                                [
                                                  _c(
                                                    "thead",
                                                    {
                                                      staticClass:
                                                        "table-header",
                                                    },
                                                    [
                                                      _c(
                                                        "tr",
                                                        {
                                                          attrs: {
                                                            align: "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-index",
                                                            },
                                                            [_vm._v("STT")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticStyle: {
                                                                "text-align":
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Chức năng"
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Hiển thị")]
                                                          ),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "table-action",
                                                            },
                                                            [_vm._v("Mở khóa")]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("tbody", [
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("22")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thông báo hệ thống"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .notifyShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "notifyShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.notifyShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .notify,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "notify",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.notify",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("23")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Hỗ trợ"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .supportShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "supportShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.supportShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .support,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "support",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.support",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("24")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thu chi nội bộ"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cashInternalShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cashInternalShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cashInternalShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .cashInternal,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "cashInternal",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.cashInternal",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("25")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Ví"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .walletShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "walletShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.walletShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .wallet,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "wallet",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.wallet",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("26")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Tin tức"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .newsShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "newsShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.newsShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .news,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "news",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.news",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("27")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Xin nghỉ nhân sự"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .absentTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "absentTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.absentTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("28")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Chấm công nhân sự\n                          "
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("29")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Công lương nhân sự"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("30")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Thống kê công lương"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .statisticSalaryTeacherShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "statisticSalaryTeacherShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.statisticSalaryTeacherShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .statisticSalaryTeacher,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "statisticSalaryTeacher",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.statisticSalaryTeacher",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("31")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Bảng lương"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherShowNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherShowNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherShowNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .salaryTeacherNew,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "salaryTeacherNew",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.salaryTeacherNew",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("32")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Tổng học sinh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .totalKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "totalKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.totalKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .totalKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "totalKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.totalKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("33")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Đang học"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studyingKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studyingKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studyingKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .studyingKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "studyingKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.studyingKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("34")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đã điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("35")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Chưa điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .noAttendanceKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "noAttendanceKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.noAttendanceKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .noAttendanceKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "noAttendanceKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.noAttendanceKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("36")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Đi học"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .goSchoolKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "goSchoolKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.goSchoolKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .goSchoolKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "goSchoolKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.goSchoolKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("37")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đã điểm danh về"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .leaveSchoolKidStatisticShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "leaveSchoolKidStatisticShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.leaveSchoolKidStatisticShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .leaveSchoolKidStatistic,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "leaveSchoolKidStatistic",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.leaveSchoolKidStatistic",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("38")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Đi học dự kiến"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnFutureStatusShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnFutureStatusShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnFutureStatusShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .learnFutureStatus,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "learnFutureStatus",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.learnFutureStatus",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("39")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Mã QR"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qrCodeShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qrCodeShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qrCodeShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qrCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qrCode",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qrCode",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("40")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v("Nhận diện"),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .faceRecognitionShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "faceRecognitionShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.faceRecognitionShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .faceRecognition,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "faceRecognition",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.faceRecognition",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("41")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý điểm danh"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qlAttendanceShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qlAttendanceShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qlAttendanceShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .qlAttendance,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "qlAttendance",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.qlAttendance",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "tr",
                                                      {
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-index",
                                                          },
                                                          [_vm._v("42")]
                                                        ),
                                                        _c("td", [
                                                          _vm._v(
                                                            "Quản lý nhận diện AI"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceAIShow,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceAIShow",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceAIShow",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "table-action",
                                                          },
                                                          [
                                                            _c("el-checkbox", {
                                                              model: {
                                                                value:
                                                                  _vm
                                                                    .iconPlusData
                                                                    .attendanceAI,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.iconPlusData,
                                                                      "attendanceAI",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "iconPlusData.attendanceAI",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("br"),
      _c("br"),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialogByButton("iconParentData")
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v("Đóng")]),
            ]
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
                mini: "",
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v("Lưu")]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }